module.exports = __webpack_public_path__ + "statics/img/SAAS.1d72f9a1.png";